export const arrivalTimeConfig = {
  start: 18,
  end: 23,
  gap: 15,
}